const defaultColors = {
  black: "#333333",
  lightBlueHLS: "hsl(200, 97%, 98%)",
  blue: "#04A6F4",
  lightBlue: "#E5F5FD",
  darkBlue: "rgb(7,67,122)",
  lightGreen: "#33CC33",
  gray: "#f0f0f5",
  lightGrey: "#CCCCCC",
  lightLightGrey: "#ebebeb",
  darkGrey: "#3F3D56",
  green: "rgba(78, 227, 193)",
  darkGreen: "#33cc33",
  pink: "#fd79a8",
  orange2: "#FFB95F",
  orange: "#ff9100",
  red: "#f25e40",
  red2: "#FF0000",
  yellow: "#f7df02",
  darkRed: "#BD0A05",
  white: "#fff",
  ashGrey: "#ACABAB",

  ai: {
    purple: "#0041DD",
    darkBlue: "#071F4F",
    grayDark: "#979797",
    grayLight: "#C2C2C2",
    grayWhite: "#F0F0F5",
  },
};

const colors = {
  black: defaultColors.black,
  blackRGB: [63, 61, 86],
  darkGreen: defaultColors.darkGreen,
  red: defaultColors.red,
  red2: defaultColors.red2,
  darkRed: defaultColors.darkRed,
  blue: defaultColors.blue,
  gray: defaultColors.gray,
  lightGreen: defaultColors.lightGreen,
  lightGrey: defaultColors.lightGrey,
  lightLightGrey: defaultColors.lightLightGrey,
  darkGrey: defaultColors.darkGrey,
  orange: defaultColors.orange,
  green: defaultColors.green,
  white: defaultColors.white,
  ashGrey: defaultColors.ashGrey,
  orange2: defaultColors.orange2,
  lightBlue: defaultColors.lightBlueHLS,
  darkBlue: defaultColors.darkBlue,
  yellow: defaultColors.yellow,

  ai: {
    purple: defaultColors.ai.purple,
    darkBlue: defaultColors.ai.darkBlue,
    grayDark: defaultColors.ai.grayDark,
    grayLight: defaultColors.ai.grayLight,
    grayWhite: defaultColors.ai.grayWhite,
  },
  screen: {
    primary: defaultColors.white,
    secondary: "#F9F9FB",
    footer: defaultColors.darkGrey,
  },
  scrollbar: "#a7a7a7",
  input: {
    border: defaultColors.lightGrey,
    focus: defaultColors.blue,
    filled: defaultColors.ai.darkBlue,
  },
  error: defaultColors.red,
  menu: {
    background: defaultColors.white,
    border: defaultColors.lightGrey,
    name: defaultColors.darkGrey,
    role: defaultColors.darkGrey,
  },
  status: {
    signed: defaultColors.green,
    updated: defaultColors.orange,
    created: defaultColors.blue,
    closed: defaultColors.darkGrey,
    approved: defaultColors.pink,
  },
  button: {
    background: {
      primary: defaultColors.blue,
      secondary: defaultColors.white,
      disabled: defaultColors.lightGrey,
      red: defaultColors.red,
    },
    color: {
      primary: defaultColors.white,
      secondary: defaultColors.black,
    },
  },
  notification: {
    background: {
      primary: defaultColors.lightBlue,
      secondary: defaultColors.orange,
    },
    color: {
      primary: defaultColors.white,
      secondary: defaultColors.white,
    },
  },
  svg: {
    primary: defaultColors.darkGrey,
    secondary: defaultColors.blue,
  },
  font: {
    blue: defaultColors.blue,
    darkGrey: defaultColors.darkGrey,
    black: defaultColors.black,
    white: defaultColors.white,
    red: defaultColors.red,
  },
  group: {
    blue: defaultColors.darkBlue,
  },
};

export default colors;
